import { Component, OnDestroy, Input, ViewEncapsulation, AfterViewInit, OnChanges, SimpleChanges} from '@angular/core';
import { NbThemeService } from '@nebular/theme';
import { ResizedEvent } from 'angular-resize-event';
import { Social_Platform,
  Material_Design_Red, 
  Material_Design_Pink, 
  Material_Design_Purple, 
  Material_Design_Deep_Purple } from '../config/color-palettes';
  import { DEFAULT_THEME as defaultTheme } from '@nebular/theme';


@Component({
  selector: 'nbx-radar-echart',
  templateUrl: './radar.component.html',
  styleUrls: ['./radar.component.scss'],
  // encapsulation: ViewEncapsulation.ShadowDom
})
export class RadarEchartsComponent implements AfterViewInit, OnChanges{
  @Input() resizable: boolean = true;
  autoResize = true;

  width: number;
  height: number;

  echartsInstance: any;

  onResized(event: ResizedEvent) {
    this.width = event.newWidth;
    this.height = event.newHeight;

    if (this.echartsInstance)
    {
      this.echartsInstance.resize({
        height: event.newHeight
      });
    }
  }

  themeSubscription: any;
  defaultThemeVariables = defaultTheme.variables;
  @Input() tooltipstr: string = '';
  @Input() legendstr: string = '';
  @Input() seriesstr: string = '';
  @Input() titlestr: string = '';
  @Input() radarstr: string = '';
  @Input() indicators = [
    { name: 'Sales', max:6500 },
    { name: 'Administration', max: 16000 },
    { name: 'Information Techology', max: 30000 },
    { name: 'Customer Support', max: 38000 },
    { name: 'Development', max: 52000 },
    { name: 'Marketing', max: 25000 },
  ]

  options: any = {};
  title: any;
  tooltip: any;
  legend: any;
  series: any;
  radar: any;

  ngAfterViewInit() {

    //Set defaults
    this.tooltip = (this.tooltipstr == '') ? {
        trigger: 'item',
      } : JSON.parse(this.tooltipstr);

    this.legend = {
      data: ['Allocated Budget', 'Actual Spending'],
      textStyle: {
        color: this.defaultThemeVariables.fgText,
      },
    }

    this.title = (this.titlestr == '') ? {
      text: '',
      subtext: '',
      left: 'center'
    } : JSON.parse(this.titlestr);  

    this.radar = (this.radarstr == '') ? {
      name: {
        textStyle: {
          color: this.defaultThemeVariables.fgText,
        },
      },
      indicator: this.indicators ,
      splitArea: {
        areaStyle: {
          color: 'transparent',
        },
      },
    } : JSON.parse(this.radarstr);

    this.series = (this.seriesstr == '') ?
      [
        {
          name: 'Budget vs Spending',
          type: 'radar',
          data: [
            {
              value: [4300, 10000, 28000, 35000, 50000, 19000],
              name: 'Allocated Budget',
            },
            {
              value: [5000, 14000, 28000, 31000, 42000, 21000],
              name: 'Actual Spending',
            },
          ]
        },
      ] : JSON.parse(this.seriesstr);

    this.options = {
      backgroundColor: 'transparent',
      color: Object.values(Material_Design_Deep_Purple),
      title: this.title,
      tooltip: this.tooltip,
      legend: this.legend,
      radar: this.radar,
      series: this.series
    };
  }


  ngOnChanges(changes: SimpleChanges) {
    for (const propName in changes)
    {
      if (changes.hasOwnProperty(propName))
      {
        switch(propName) {
          case 'tooltipstr': {
            console.log("tooltip update");
              this.updateOptions('tooltip',this.tooltipstr);
            break;     
          }
          case 'titlestr': {
            console.log("title update");
              this.updateOptions('title',this.titlestr);
            break;     
          }
          case 'legendstr': {
            console.log("legend update");
              this.updateOptions('legend',this.legendstr);
            break;
          }
          case 'seriesstr': {
            console.log("series update");
              this.updateOptions('series',this.seriesstr);
            break;
          }
          case 'radarstr': {
            console.log("radar update");
              this.updateOptions('radar',this.radarstr);
            break;
          }
        }
      }
    }

    this.options = {
      backgroundColor: 'transparent',
      color: Object.values(Material_Design_Pink),
      title: this.title,
      tooltip: this.tooltip,
      radar: this.radar,
      legend: this.legend,
      series: this.series
    }

  }

  onChartInit(e: any) {
    this.echartsInstance = e;
    console.log('on chart init:', e);
  }

  private updateOptions(opt, value) {
    console.log(opt)
    console.log(value)
    this[opt] = JSON.parse(value);
    console.log(this.tooltip);

    this.options[opt] = this[opt];

    console.log(this.options);  
  }

}